export * from './models/parking-spot.model';
export * from './models/property.model';

export * from './utils/property.utils';
export * from './utils/test.utils';
